var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dayIcon)?_c('b-icon',{staticClass:"dcs-success",attrs:{"icon":"check-circle-outline"}}):_c('b-icon',{staticClass:"dcs-danger",attrs:{"icon":"close-circle-outline"}})}
var staticRenderFns = []

export { render, staticRenderFns }